import customFieldTypes from "../types/field.types";

export const dropdownFieldItemIdAnalyticsTitleMap = {
    [customFieldTypes.purchaseIntentionFieldTypeItemId]: 'PurchaseIntention',
    [customFieldTypes.contactReasonFieldTypeItemId]: 'ContactReason',
    [customFieldTypes.decisionRoleFieldTypeItemId]: 'DecisionRole',
    [customFieldTypes.purchaseTimingFieldTypeItemId]: 'PurchaseTiming',
    [customFieldTypes.productOfInterestFieldTypeItemId]: 'ProductOfInterest',
    [customFieldTypes.customProductOfInterestFieldTypeItemId]: 'CustomProductOfInterest',
    [customFieldTypes.BusinessSegmentFieldTypeItemId]: 'BusinessSegment',
    [customFieldTypes.dealerNotesDropdownListFieldTypeItemId]: 'DealerNotes',
}